import { Flex, Group, Stack, Text } from '@mantine/core';

import { AliasAddButton } from '@/module/Dashboard/components/AliasAddButton';
import { AliasPill } from '@/module/Dashboard/components/AliasPill';

export interface AliasListProps {
  aliases: string[];
}

export function AliasList({ aliases }: AliasListProps) {
  return (
    <Stack>
      <Flex justify="space-between">
        <div>
          <Text>Aliasuri revendicate:</Text>
        </div>
        <AliasAddButton />
      </Flex>
      <Group>
        {aliases.map(alias => (
          <AliasPill
            key={alias}
            alias={alias}
          />
        ))}
      </Group>
    </Stack>
  );
}
